import ExaminerCheatSheet from './ExaminerCheatSheet';

const config = {
  subjectKey: 'english',
  path: '/gcse-english-examiner-tips',
  crumbLabel: 'GCSE English Examiner Tips',
  appHubPath: '/gcse-english-revision',
  appHubLabel: 'GCSE English revision',
  seoTitle: 'GCSE English Examiner Tips Cheat Sheet (Macbeth, ACC, Inspector Calls + more)',
  seoDescription:
    'Free printable GCSE English examiner tips cheat sheet. AO1-AO4 secrets, what AQA wants on Macbeth, A Christmas Carol, An Inspector Calls, Power & Conflict, Lang Paper 1 and Paper 2.',
  h1: 'GCSE English Examiner Tips — Grade-9 moves on every set text',
  heroLede:
    'Print this once. Stick it on the wall. Macbeth, A Christmas Carol, An Inspector Calls, Power & Conflict, unseen poetry, Lang Paper 1 and Paper 2 — each topic gets the four examiner blocks: why marks are lost, what examiners want, common traps and the Grade-9 move.',
  related: [
    { href: '/gcse-english-revision',                 testid: 'english-hub',   kicker: 'Subject hub',  title: 'Full GCSE English revision guide' },
    { href: '/gcse-maths-examiner-tips',              testid: 'maths-tips',    kicker: 'Cheat sheet',  title: 'GCSE Maths Examiner Tips' },
    { href: '/gcse-science-examiner-tips',            testid: 'science-tips',  kicker: 'Cheat sheet',  title: 'GCSE Science Examiner Tips' },
    { href: '/free-revision-planner',                 testid: 'planner',       kicker: 'Free tool',    title: 'GCSE Revision Planner (printable)' },
  ],
};

export default function GCSEEnglishExaminerTips() {
  return <ExaminerCheatSheet config={config} />;
}
